// import axios from 'axios'
import baseURL from '../baseUrl'

// 列表
export function shoppingCart(data) {
  var url=baseURL?'/getShopCartList':'/api/getShopCartList'
  return axios({
    // url: '/pc_shoppingCart',
    url,
    method: 'post',
    params: data
  })
}

export function addShoppingCart(data) {
  var url=baseURL?'/addShopCartNum':'/api/addShopCartNum'
  return axios({
    // url: '/pc_addShoppingCart',
    url,
    method: 'post',
    params: data
  })
}
// 获取更新购物车商品数量
export function getCartNum(data) {
  var url=baseURL?'/pc_getCartNum':'/api/pc_getCartNum'
  return axios({
    url,
    method: 'post',
    params: data
  })
}

// 更新购物车商品数量
export function updateCartNum(data) {
  var url=baseURL?'/updateShopCartNum':'/api/updateShopCartNum'
  return axios({
    // url: '/pc_updateCartNum',
    url,
    method: 'post',
    params: data
  })
}

// 更新购物车商品数量
export function toFavorites(data) {
  var url=baseURL?'/pc_toFavorites':'/api/pc_toFavorites'
  return axios({
    url,
    method: 'post',
    params: data
  })
}

// 更新购物车商品数量
export function deleteCart(data) {
  var url=baseURL?'/deleteCartGoods':'/api/deleteCartGoods'
  return axios({
    // url: '/pc_deleteCart',
    url,
    method: 'post',
    params: data
  })
}

// 提交订单
export function submitOrder(data) {
  var url=baseURL?'/pc_submitOrder':'/api/pc_submitOrder'
  return axios({
    url,
    method: 'post',
    params: data
  })
}

// 修改订单商品配置
export function changeConfig(data) {
  var url=baseURL?'/changeConfig':'/api/changeConfig'
  return axios({
    url,
    method: 'post',
    params: data
  })
}



// WEBPACK FOOTER //
// ./src/api/shoppingcart/shopping_cart.js